import React from 'react';

/*
 *  @Description:   Stateless component that renders an UnavailableOfflineIcon.
 */

const UnavailableOffline = ( props ) => {

    return (<g id="path">
            <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
        </g>
    )
};

export default UnavailableOffline;

